import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { resetSimilarPartFiltersAutoSet } from '../redux/slices/filtersSlice';

const useFilterUrl = () => {
	const dispatch = useDispatch();
	const similarPartsFiltersAutoSet = useSelector(state => state.filters.similarParts.autoSet);
	// const maxValuesForAllFilter with useSelector
	function createNewSearchString(cid, values) {
		if (!values) {
			return `?${cid}=!()`;
		}

		if (Array.isArray(values) && values.every(item => typeof item === 'string')) {
			const cleanedValues = values.map(str => str.replace(/\s/g, '_').replace(/,/g, '~'));
			return `?${cid}=(${cleanedValues.join(';')})`;
		} else if (typeof values === 'string') {
			return `?${cid}=(${encodeURIComponent(values.replace(/\s/g, '_'))})`;
		} else {
			return Array.isArray(values) && values.length === 2 ? `?${cid}=(${values[0]};${values[1]})` : `?${cid}=${values}`;
		}
	}

	function changeCurrentFilters(currentFilters, cid, values) {
		let cleanedValues;
		if (Array.isArray(values)) {
			cleanedValues = values.map(item =>
				typeof item === 'string' ? item.replace(/\s/g, '_').replace(/,/g, '~') : item
			);
		} else if (typeof values === 'string') {
			return `(${values.replace(/\s/g, '_')})`;
		} else {
			return values;
		}

		let logicPrefix = '';
		if (cid in currentFilters && currentFilters[cid].startsWith('!')) {
			logicPrefix = '!';
		}

		return `${logicPrefix}(${cleanedValues.join(';')})`;
	}

	function updateURL(currentFilters) {
		const newSearch = `?${queryString.stringify(currentFilters, {
			encode: false
		})}`;
		const encodedURL = encodeURI(newSearch);
		window.history.pushState({ pathname: window.location.pathname, search: encodedURL }, '', encodedURL);
	}

	function changeFilterLogic(cid, logic) {
		let currentFilters = queryString.parse(window.location.search);

		if (!(cid in currentFilters)) {
			currentFilters[cid] = '()';
		}

		const shouldBeNegated = logic === 'NOT';

		if (shouldBeNegated && !currentFilters[cid].startsWith('!')) {
			currentFilters[cid] = `!${currentFilters[cid]}`;
		} else if (!shouldBeNegated && currentFilters[cid].startsWith('!')) {
			currentFilters[cid] = currentFilters[cid].substring(1);
		}
		// Loop all cleaned parameters, then only for slider parameters in url, update MAX or MIN values, if missing
		updateURL(currentFilters);
	}

	const removeUtmParameters = currentFilters => {
		const utmParams = ['utm_source', 'utm_medium', 'utm_region', 'utm_content', 'utm_campaign'];
		utmParams.forEach(utmParam => {
			if (currentFilters[utmParam]) {
				delete currentFilters[utmParam];
			}
		});
	};

	function changeFilterURL(cid, values) {
		let currentFilters = queryString.parse(window.location.search);
		removeUtmParameters(currentFilters);
		if (values) {
			currentFilters[cid] = changeCurrentFilters(currentFilters, cid, values);
		}
		if (currentFilters[cid] === '()' || !values) {
			delete currentFilters[cid];
		}
		if (window.location.search.length <= 1) {
			const newSearch = createNewSearchString(cid, values);
			const encodedURL = encodeURI(newSearch);
			window.history.pushState({ pathname: window.location.pathname, search: encodedURL }, '', encodedURL);
		} else {
			updateURL(currentFilters);
		}
		if (similarPartsFiltersAutoSet) {
			dispatch(resetSimilarPartFiltersAutoSet());
		}
	}

	function resetURL() {
		window.history.pushState({ pathname: window.location.pathname, search: '' }, '', window.location.pathname);
	}

	return { changeFilterURL, changeFilterLogic, resetURL, removeUtmParameters };
};

export default useFilterUrl;
